// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChatManager_wrapper__1Lcpx"};